import { Injectable, computed, inject, signal } from '@angular/core';
import { ApiService, SpinnerService } from '@core/services';
import { Business } from '../models/business.model';
import { Observable } from 'rxjs';
import { Cookies } from 'typescript-cookie';
import { TemplateName } from '../models';
import { GeneralResponse } from '@core/models';

@Injectable({
  providedIn: 'root',
})
export class BusinessService {
  private apiService = inject(ApiService);

  storeBusiness(data: Business): Observable<Business> {
    data.createdBy = Cookies.get('workerId') as string;
    return this.apiService.store('business', data);
  }

  #business = signal(0);
  business = computed<number>(() => this.#business());

  setBusiness(id: number) {
    this.#business.set(id);
  }

  postBusiness(
    data: Business,
    logo?: string
  ): Observable<GeneralResponse<Business>> {
    data.logo = logo;
    return this.apiService.post<Business>('business', data);
  }

  putBusiness(
    idBusiness: number,
    data: Business,
    logo?: string
  ): Observable<GeneralResponse<string>> {
    data.logo = logo;
    return this.apiService.put<string>(`business`, data, idBusiness);
  }

  putUsersAccount(
    idBusiness: number,
    usersCount: number,
    sendMail: boolean
  ): Observable<GeneralResponse<string>> {
    return this.apiService.put<string>(
      `business/usersAccount`,
      { usersCount, sendMail },
      idBusiness
    );
  }

  getBusiness(): Observable<Business> {
    return this.apiService.getAll('business');
  }

  getBusinessByID(idBusinss: number | string): Observable<Business> {
    return this.apiService.getAll(`business/${idBusinss}`);
  }

  getBusinessByCode(code: string): Observable<Business> {
    return this.apiService.getAll(`business/code/${code}`);
  }

  updateBusiness(idBusiness: number, data: Business): Observable<Business> {
    return this.apiService.update(`business/${idBusiness}`, data, idBusiness);
  }

  sendEmail(business_Id: number | undefined, template_name: TemplateName) {
    return this.apiService.post<string>('business/BusinessStateSendEmail', {
      business_Id,
      template_name,
    });
  }

  suspend(id: number | undefined) {
    return this.apiService.post<string>(`accountStatus/suspend?id=${id}`, {});
  }

  reactivate(id: number | undefined) {
    return this.apiService.post<string>(
      `accountStatus/reactivate?id=${id}`,
      {}
    );
  }
}
